export enum FieldType {
  text_area = 'text_area',
  // entity_type = 'entity_type',
  entity_name = 'entity_name',
  url = 'url',
  email = 'email',
  decimal = 'decimal',
  ranking = 'ranking',
  relation_multiple = 'relation_multiple',
  account_class = 'account_class',
  // cloud_picture = 'cloud_picture',
  // sharing = 'sharing',
  owner = 'owner',
  owner_or_unassigned = 'owner_or_unassigned',
  phone = 'phone',
  // relation_nullable = 'relation_nullable',
  input = 'input',
  // modified = 'modified',
  account_card = 'account_card',
  parent_account_card = 'parent_account_card',
  project_account_card = 'project_account_card',
  dropdown = 'dropdown',
  sales_unit = 'sales_unit',
  unit_membership = 'unit_membership',
  primary_key_uuid = 'primary_key_uuid',
  // created = 'created',
  country = 'country',
  // share_mode = 'share_mode',
  account_name = 'account_name',
  contact_name = 'contact_name',
  integer = 'integer',
  integer_nullable = 'integer_nullable',
  float = 'float',
  float_nullable = 'float_nullable',
  lookup = 'lookup',
  tags = 'tags',
  currency = 'currency',
  currency_id = 'currency_id',
  currency_foreign = 'currency_foreign',
  date = 'date',
  datetime = 'datetime',
  // daterange = 'daterange',
  contact_card = 'contact_card',
  contact_account_card = 'contact_account_card',
  project_contact_card = 'project_contact_card',
  sequence = 'sequence',
  radio = 'radio',
  checkbox = 'checkbox',
  multiselect_checkbox = 'multiselect_checkbox',
  closing_date = 'closing_date',
  location = 'location',
  product_services = 'product_services',
  due_date = 'due_date',
  priority = 'priority',
  attachments = 'attachments',
  linked_items = 'linked_items',
  sales_step = 'sales_step',
  gender = 'gender',
  sequence_pattern = 'sequence_pattern',
  duration_date = 'duration_date',
  duration_datetime = 'duration_datetime',
  watchers_editors = 'watchers_editors',
  entity_type = 'entity_type',
  share_mode = 'share_mode',
  sharing = 'sharing',
  string = 'string',
  account_role = 'account_role',
  org_relationship_type = 'org_relationship_type',
  created = 'created',
  modified = 'modified',
  health_category = 'health_category',
  health_status = 'health_status',
  industry = 'industry',
  position = 'position',
  product_name = 'product_name',
  percent = 'percent',
  ranking_percent = 'ranking_percent',
  timespan = 'timespan',
  timeframe_age = 'timeframe_age',
  target_value = 'target_value',
  product_quantity = 'product_quantity',
  product_price = 'product_price',
  product_amount = 'product_amount',
  duration = 'duration',
  kpi_datetime = 'kpi_datetime',
  daterange = 'daterange',
  date_daterange = 'date_daterange',
  datetime_only_filterable = 'datetime_only_filterable',
  relation = 'relation',
  relation_nullable = 'relation_nullable',
  task_status = 'task_status',
  activity_status = 'activity_status',
  project_status = 'project_status',
  email_tracking_status = 'email_tracking_status',
  email_type = 'email_type',
  email_sentiment = 'email_sentiment',
  email_direction = 'email_direction',
  product_category = 'product_category',
  entity_link = 'entity_link',
  client_name = 'client_name',
  pipeline = 'pipeline',
  lead_process = 'lead_process',
  warning_level = 'warning_level',
  lead_status = 'lead_status',
  oppty_status = 'oppty_status',
  share_actor = 'share_actor',
  content_share_mode = 'content_share_mode',
  primary_key_string = 'primary_key_string',
  multiselect_checkbox_only_filterable = 'multiselect_checkbox_only_filterable',
  linked_item_types = 'linked_item_types',
  oppty_lead_icon = 'oppty_lead_icon',
  sales_role = 'sales_role',
  label_flag = 'label_flag',
  fitness_indicators = 'fitness_indicators',
  sales_step_activity = 'sales_step_activity',
  access_level = 'access_level',
  access_level_bool = 'access_level_bool',
  parent_account = 'parent_account',
  favorite = 'favorite',
  bool = 'bool',
  bool_not_required = 'bool_not_required',
  scoring_category = 'scoring_category',
  scoring_status = 'scoring_status',
  static_profiles = 'static_profiles',
  quote_process = 'quote_process',
  quote_status = 'quote_status',
  rating = 'rating',
  won_date = 'won_date',
  lost_date = 'lost_date',
  product_card = 'product_card',
  oppty_card = 'oppty_card',
  rollup = 'rollup',
  attendees_emails = 'attendees_emails',
  primary_key_fk = 'primary_key_fk',
  product_pipelines = 'product_pipelines',
  calculated_formula = 'calculated_formula', // advanced formula
  geo_location = 'geo_location',
  file_upload = 'file_upload',
  online_form_product_services = 'online_form_product_services',
  social_media = 'social_media',
  cloud_picture = 'cloud_picture',
  json_nullable = 'json_nullable',
}
